import styled from 'styled-components'

export const Container = styled.div`
  text-align: center;
  width: 30%;
  margin: 10rem auto;
`
